import { refsService } from '@/services/apiRequests/refs.service';

export default {
    namespaced: true,
    state: {
        districts: [],
        centerBosses: [],
        customerServiceList: [],
        inspectors: [],
        injuctions: [],
        reasons: [],
        actions: [],
        shutdown: [],
        heatingSystem: [],
        engineers: [],
        jobPositionTypes: []
    },
    getters: {
        getDistricts(state) {
            return state.districts;
        },
        getCenterBosses(state) {
            return state.centerBosses;
        },
        getCustomerServiceList(state) {
            return state.customerServiceList;
        },
        getInspectorsList(state) {
            return state.inspectors;
        },
        getInjuctionsList(state) {
            return state.injuctions;
        },
        getReasonsList(state) {
            return state.reasons;
        },
        getActionsList(state) {
            return state.actions;
        },
        getShutdownList(state) {
            return state.shutdown;
        },
        getHeatingSystem(state) {
            return state.heatingSystem;
        },
        getJobPositionTypes(state) {
            return state.jobPositionTypes;
        }
    },
    mutations: {
        setDistricts(state, rowCount) {
            state.districts = rowCount;
        },
        setCenterBosses(state, centerBosses) {
            state.centerBosses = centerBosses;
        },
        setCustomerServiceList(state, serviceList) {
            state.customerServiceList = serviceList;
        },
        setInspectors(state, inspectors) {
            state.inspectors = inspectors;
        },
        setInjuctions(state, injuctions) {
            state.injuctions = injuctions;
        },
        setReasons(state, reasons) {
            state.reasons = reasons;
        },
        setActions(state, actions) {
            state.actions = actions;
        },
        setShutdown(state, shutdown) {
            state.shutdown = shutdown;
        },
        setHeatingSystem(state, heatingSystem) {
            state.heatingSystem = heatingSystem;
        },
        setEngineers(state, engineers) {
            state.engineers = engineers;
        },
        setJobPositionTypes(state, jobPositionTypes) {
            state.jobPositionTypes = jobPositionTypes;
        }
    },
    actions: {
        async getDistricts({ commit }) {
            const response = await refsService.getDistricts();
            if (response.message === 'OK') {
                commit('setDistricts', response.data['isas_districts']);
            }
        },
        async fetchCenterBosses({ commit }, payload) {
            const response = await refsService.fetchCenterBosses(payload);
            if (response.successfull) {
                commit('setCenterBosses', response.data['ahs_center_bosses']);
            }
        },
        async fetchCustomerServiceList({ commit }) {
            const response = await refsService.getCustomerServiceList();
            if (response.successfull) {
                commit('setCustomerServiceList', response.data);
            }
        },
        async getInspectors({ commit }) {
            const response = await refsService.getInspectors();
            if (!response.successfull) return;
            commit('setInspectors', response.data);
        },
        async getInjuctions({ commit }) {
            const response = await refsService.getInjuctions();
            if (!response.successfull) return;
            commit('setInjuctions', response.data);
        },
        async getReasons({ commit }) {
            const response = await refsService.getReasons();
            if (!response.successfull) return;
            commit('setReasons', response.data);
        },
        async getActions({ commit }) {
            const response = await refsService.getActionsTypes();
            if (!response.successfull) return;
            commit('setActions', response.data);
        },
        async getShutdown({ commit }) {
            const response = await refsService.getShutdownTypes();
            if (!response.successfull) return;
            commit('setShutdown', response.data);
        },
        async getHeatingSystem({ commit }) {
            const response = await refsService.getRefHeatingSystem();
            if (!response.successfull) return;
            commit('setHeatingSystem', response.data);
        },
        async fetchEngineers({ commit }) {
            const response = await refsService.getEngList();
            if (!response.successfull) return;
            commit('setEngineers', response.data['isas_engineer']);
        },
        async getJobPositionTypes({ commit }) {
            const response = await refsService.getJobPositionTypes();
            if (!response.successfull) return;
            commit('setJobPositionTypes', response.data);
        }
    }
};
